export default getText => key =>
  ({
    processing: getText('Processing', 'Patient_Details_Modal_Scheduled'),
    btnLabelNext: getText('Next', 'Patient_Details_Modal_Scheduled'),
    btnLabelSent: getText('Request sent!', 'Patient_Details_Modal_Scheduled'),
    btnLabelAppoint: getText('Send request', 'Patient_Details_Modal_Scheduled'),
    btnLabelClose: getText('Close', 'Patient_Details_Modal_Scheduled'),
    btnLabelCancel: getText('Cancel', 'Patient_Details_Modal_Scheduled'),
  }[key])
